(ns manage.variants-preview-panel.db.core
  (:require [manage.variants-preview-panel.db.variants]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]))

(def auto-play-localstorage-key "variants-preview-auto-play")
(def auto-mute-localstorage-key "variants-preview-auto-mute")
(def zoom-level-localstorage-key "variants-preview-zoom-level")

(def initial-state {:sidebar-visible nil
                    :feed-id nil
                    :display-mode :gallery})

(def forward-events
  [{:register :variants-preview.core/init-variants
    :events #{:resource.content-variants/get-variants-for-preview-success}
    :dispatch-to [:variants-preview.variants/init]}
   {:register :variants-preview.core/get-next
    :events #{:resource.content-variants/get-next-success}
    :dispatch-to [:variants-preview.core/init-previews]}
   {:register :variants-preview.core/content-unavailable-gallery
    :events #{:resource.content-variants/get-next-failure}
    :dispatch-to [:modal/open {:id :missing-content-modal}]}
   {:register :variants-preview.core/content-unavailable-sbs
    :events #{:resource.content-variants/get-variants-for-preview-failure}
    :dispatch-to [:modal/open {:id :missing-content-modal}]}])

;; Component initializing
(rf/reg-event-fx :variants-preview.core/init
  [(rf/inject-cofx :query-params)
   (rf/inject-cofx :localstorage [auto-play-localstorage-key auto-mute-localstorage-key])]
  (fn [{:keys [db query-params]
        :localstorage/keys [variants-preview-auto-play variants-preview-auto-mute]} _]
    {:db (-> db
             (update :variants-preview.core (fn [x] (merge initial-state
                                                           query-params
                                                           ;; Don't reset display-mode on shadow-cljs reload
                                                           (select-keys x [:display-mode]))))
             (update-in [:variants-preview.core] assoc
                        :auto-play (or (nil? variants-preview-auto-play) variants-preview-auto-play)
                        :auto-mute (or (nil? variants-preview-auto-mute) variants-preview-auto-mute)))
     :fx [[:dispatch [:resource.adset-preview/get-adset-data]]
          [:forward-events forward-events]]}))

(rf/reg-event-fx :variants-preview.core/init-previews
  [(rf/inject-cofx :localstorage [zoom-level-localstorage-key])]
  (fn [{:keys [db]
        :localstorage/keys [variants-preview-zoom-level]} _]
    (let [first-render (get-in db [:resource.content-variants/adjacent :current :data :renders 0])
          video-width (get-in first-render [:job-result :width])
          video-height (get-in first-render [:job-result :height])
          video-area (- (.-innerWidth js/window) 400) ; width of the side panel + padding for video
          resize (cond (<= video-area (* video-width 0.5)) 0.25
                       (<= video-area (* video-width 0.75)) 0.5
                       (< video-area video-width) 0.75
                       :else 1)
          current-width (get-in db [:variants-preview.core :video-width])
          current-height (get-in db [:variants-preview.core :video-height])]
      {:db (update db :variants-preview.core assoc
                   :orig-width video-width
                   :orig-height video-height
                   :aspect-ratio (/ video-width video-height)
                   :orig-zoom-level 100
                   :video-width (if (and (int? current-width) (> current-width 0))
                                  current-width
                                  (when (not= resize 1) (* resize video-width)))
                   :video-height (if (and (int? current-height) (> current-height 0))
                                   current-height
                                   (when (not= resize 1) (* resize video-height)))
                   :zoom-level (when (not= resize 1) (* resize 100)))
       :fx [(when (some? variants-preview-zoom-level)
              [:dispatch [:variants-preview.core/set-zoom-level variants-preview-zoom-level]])]})))

(rf/reg-event-fx :variants-preview.core/destroy
  (fn [{:keys [db]} _]
    ;; FIXME: This destroys the state on re-frame reload also, makes development painful
    {:db (dissoc db :variants-preview.core)
     :forward-events (mapv #(hash-map :unregister (:register %))
                           forward-events)}))

(rf/reg-event-db :variants-preview.core/set-sidebar-visible
  (fn [db [_ is-visible]]
    (assoc-in db [:variants-preview.core :sidebar-visible] is-visible)))

(rf/reg-event-db :variants-preview.core/change-display-mode
  (fn [db [_ target]]
    (assoc-in db [:variants-preview.core :display-mode] (keyword target))))

(rf/reg-sub :variants-preview.core/value
  (fn [db [_ path default]]
    (get-in db [:variants-preview.core path] default)))

(rf/reg-sub :variants-preview.core/auto-play
  (fn [db _]
    (get-in db [:variants-preview.core :auto-play])))

(rf/reg-sub :variants-preview.core/auto-mute
  (fn [db _]
    (get-in db [:variants-preview.core :auto-mute])))

(rf/reg-sub :variants-preview.core/display-mode
  (fn [db _]
    (get-in db [:variants-preview.core :display-mode] "")))

(rf/reg-sub :variants-preview.core/video-width
  (fn [db _]
    (or (get-in db [:variants-preview.core :video-width])
        (get-in db [:variants-preview.core :orig-width] 270))))

(rf/reg-sub :variants-preview.core/video-height
  (fn [db _]
    (or (get-in db [:variants-preview.core :video-height])
        (get-in db [:variants-preview.core :orig-height] 270))))

(rf/reg-sub :variants-preview.core/zoom-level
  (fn [db _]
    (or
     (get-in db [:variants-preview.core :zoom-level])
     (get-in db [:variants-preview.core :orig-zoom-level]))))

(rf/reg-sub :variants-preview.core/share-url
  :<- [:url-context]
  :<- [:variants-preview.core/value :feed-id]
  :<- [:variants-preview.variants/current-cursor]
  :<- [:variants-preview.variants/current-variant-id]
  (fn [[url-context feed-id cursor variant-id]]
    (str js/window.location.origin
         (r.easy/href :common/shared-content-variants-preview url-context {:cursor cursor
                                                                           :feed-id feed-id
                                                                           :advertiser-id (:advertiser-id url-context)
                                                                           :variant-id variant-id}))))

(rf/reg-event-fx :variants-preview.core/copy-share-link
  (fn [{:keys [db]} [_ share-link]]
    {:db (assoc-in db [:variants-preview.core :link-copied] :success)
     :dispatch-later [{:ms 3000 :dispatch [:variants-preview.core/reset-link-copied]}]
     :content->clipboard {:content share-link}}))

(rf/reg-event-db :variants-preview.core/reset-link-copied
  (fn [db _]
    (update db :variants-preview.core dissoc :link-copied)))

(rf/reg-event-fx :variants-preview.core/set-auto-play
  (fn [{:keys [db]} [_ value]]
    {:db (assoc-in db [:variants-preview.core :auto-play] value)
     :localstorage/save [auto-play-localstorage-key value]}))

(rf/reg-event-fx :variants-preview.core/set-auto-mute
  (fn [{:keys [db]} [_ value]]
    {:db (assoc-in db [:variants-preview.core :auto-mute] value)
     :localstorage/save [auto-mute-localstorage-key value]}))

(rf/reg-event-fx :variants-preview.core/set-video-width
  (fn [{:keys [db]} [_ value]]
    (let [orig-width (get-in db [:variants-preview.core :orig-width])
          aspect-ratio (get-in db [:variants-preview.core :aspect-ratio])]
      {:db (update db :variants-preview.core assoc
                   :video-width value
                   :video-height (/ value aspect-ratio)
                   :zoom-level (* 100 (/ value orig-width)))
       :localstorage/save [zoom-level-localstorage-key (* 100 (/ value orig-width))]})))

(rf/reg-event-fx :variants-preview.core/set-video-height
  (fn [{:keys [db]} [_ value]]
    (let [orig-height (get-in db [:variants-preview.core :orig-height])
          aspect-ratio (get-in db [:variants-preview.core :aspect-ratio])]
      {:db (update db :variants-preview.core assoc
                   :video-width (* value aspect-ratio)
                   :video-height value
                   :zoom-level (* 100 (/ value orig-height)))
       :localstorage/save [zoom-level-localstorage-key (* 100 (/ value orig-height))]})))

(rf/reg-event-fx :variants-preview.core/set-zoom-level
  (fn [{:keys [db]} [_ value]]
    (let [orig-height (get-in db [:variants-preview.core :orig-height])
          aspect-ratio (get-in db [:variants-preview.core :aspect-ratio])
          new-height (* orig-height (/ value 100))]
      {:db (update db :variants-preview.core assoc
                   :video-width (* new-height aspect-ratio)
                   :video-height new-height
                   :zoom-level value)
       :localstorage/save [zoom-level-localstorage-key value]})))
